import React, { Component, ReactNode } from 'react';

type Props = { children: ReactNode; shell?: boolean };
type State = { error: Error | null; reloadAttempted: boolean };
const reloadKey = 'watson:asset-reload-attempted';

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, reloadAttempted: false };

  static getDerivedStateFromError(error: unknown): Partial<State> {
    return { error: error instanceof Error ? error : new Error('Render failed.') };
  }

  componentDidCatch() {
    try { this.setState({ reloadAttempted: sessionStorage.getItem(reloadKey) === '1' }); }
    catch { this.setState({ reloadAttempted: true }); }
  }

  reload = () => {
    try {
      if (sessionStorage.getItem(reloadKey) === '1') { this.setState({ reloadAttempted: true }); return; }
      sessionStorage.setItem(reloadKey, '1');
      this.setState({ reloadAttempted: true });
      window.location.reload();
    } catch { this.setState({ reloadAttempted: true }); }
  };

  render() {
    if (!this.state.error) return this.props.children;
    const assetFailure = /ChunkLoadError|Loading (?:CSS )?chunk|Failed to fetch dynamically imported module/i.test(
      `${this.state.error.name} ${this.state.error.message}`);
    return (
      <section role="alert" className="p-5 bg-white border rounded">
        {this.props.shell && <header className="mb-4">
          <strong>Watson International</strong>
          <nav aria-label="Recovery navigation" className="flex gap-4 mt-2">
            <a href="/dashboard">Dashboard</a><a href="/quotations">Quotations</a><a href="/login">Sign in</a>
          </nav>
        </header>}
        <p>{assetFailure ? 'An application file could not be loaded.' : 'Something went wrong — retry this area.'}</p>
        {assetFailure
          ? <><button type="button" className="mt-3 underline" onClick={this.reload} disabled={this.state.reloadAttempted}>Reload application once</button>
            {this.state.reloadAttempted && <p>Reload already attempted. Check your connection or try again later.</p>}</>
          : <button type="button" className="mt-3 underline" onClick={() => this.setState({ error: null })}>Retry</button>}
      </section>
    );
  }
}
